export default function () {
	return {
		status: null,
		message: null,
		success: true,

		post() {
			this.status = 'loading'

			fetch('/wp/wp-admin/admin-ajax.php?action=newsletter_subscription', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams(new FormData(this.$el)),
			})
				.then((response) => response.json())
				.then((data) => {
					this.message = data.data.message
					this.success = data.success

					this.status = null
				})
				.catch((error) => {
					this.message = error.message
					this.success = false

					this.status = null
				})
				.finally(() => this.resetTurnstile())
		},

		resetTurnstile() {
			const widget = this.$el.querySelector('.cf-turnstile')

			if (widget && window.turnstile) {
				window.turnstile.reset(widget)
			}
		},
	}
}
